export default "__VITE_ASSET__oXv98JtB__"